import Vue from 'vue'
import Meta from 'vue-meta'

// Apply a Nuxt.JS compatible configuration
Vue.use(Meta, {
  keyName: 'head',
  tagIDKeyName: 'hid',
  debounceWait: 300
})
